export default "__VITE_ASSET__DYwSd$Ql__"